<div class="row">
    <div class="col-sm-6 col-md-3">
        <div class="form-field">
            <input class="form-control"
                   name="filterId"
                   [(ngModel)]="filterValues.id"
                   [placeholder]="'notification_lblId' | translate"
                   (input)="search($event)"
                   maxlength="50">
        </div>
    </div>

    <div class="col-sm-6 col-md-3">
        <div class="form-field">
            <input class="form-control"
                   name="filterAuthor"
                   [(ngModel)]="filterValues.author"
                   [placeholder]="'notification_lblSender' | translate"
                   [disabled]="!isAdmin"
                   (input)="search($event)"
                   maxlength="50">
        </div>
    </div>

    <div class="col-sm-6 col-md-3">
        <div class="form-field">
            <app-date [(ngModel)]="filterValues.sentFrom" name="filterSentFrom"
                      [placeholder]="'notification_lblSentFrom' | translate" (dateChange)="filter()"></app-date>
        </div>
    </div>

    <div class="col-sm-6 col-md-3">
        <div class="form-field">
            <app-date [(ngModel)]="filterValues.sentTo" name="filterSentTo"
                      [placeholder]="'notification_lblSentTo' | translate" (dateChange)="filter()"></app-date>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm">
        <div class="form-field">
            <app-select name="filterStatus"
                        [placeholder]="'notification_lblStatus' | translate"
                        [(ngModel)]="filterValues.status"
                        [options]="options.status"
                        [multiple]="true"
                        [displayProperty]="'text'"
                        [valueProperty]="'value'"
                        (selectionChange)="filter()"></app-select>
        </div>
    </div>

    <div class="col-sm">
        <div class="form-field">
            <app-select name="filterType"
                        [placeholder]="'notification_lblType' | translate"
                        [(ngModel)]="filterValues.type"
                        [options]="options.type"
                        [multiple]="true"
                        [displayProperty]="'text'"
                        [valueProperty]="'value'"
                        (selectionChange)="filter()"></app-select>
        </div>
    </div>
</div>

<app-alert level="info" *ngIf="hasMore && limit > -1">
    {{'notification_moreAvailable' | translate | formatString:[limit]}}
    <br />
    <a href="#" (click)="$event.preventDefault(); loadAll()">{{'notification_btnLoadAll' | translate}}</a>
</app-alert>

<app-table [rows]="rows" [columns]="columns">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.Id}}</td>
            <td>
                <app-notification-status [value]="row.Status"></app-notification-status>
            </td>
            <td>
                <div>{{row.AuthorName}} {{row.AuthorSurname}}</div>
                <div class="text-sub">{{row.AuthorUpn}}</div>
            </td>
            <td>{{row.Finished | appDate:'datetime'}}</td>
            <td>{{row.Type}}</td>
            <td>{{row.Subject}}</td>
            <td>
                <div class="table-actions">
                    <button type="button" class="btn btn-outline btn-icon" [routerLink]="['/notifications', row.Id] | localize"
                            [ngbTooltip]="'open' | translate">
                        <i class="fi fi-rs-angle-right"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
